module.exports = __webpack_public_path__ + "img/logo.e9bc4b9a.png";